<template>
    <el-dialog
        title="选择发行平台渠道"
        :visible="visible"
        class="form-dialog"
        :append-to-body="true"
        center
        @open="getSp"
        @close="onClose"
        width="700px"
    >
        <div class="channel-dialog-content">
            <div class="channel-list">
                <div class="left">
                    <div class="title">大陆地区</div>
                    <div class="channel-rows">
                        <div v-for="item in domestic" @click="changeSp(item)" :key="item.id" :class="['channel-item', item.active ? 'active' : '']">
                            <el-image :src="$utils.coverImg(item.showLogo, 260, 260)" fit="cover">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                            <i :class="[item.active ? 'el-icon-success' : '', 'icon']"></i>
                            <p>{{ item.showName || item.name }}</p>
                            <!-- <span>（包含多个渠道）</span> -->
                        </div>
                        <div class="channel-item active more">
                            <el-image :src="require('@/assets/img/domestic.png')" fit="cover">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                            <i class="el-icon-success icon"></i>
                            <p>等其余61个平台</p>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="title">港澳台及海外</div>
                    <div class="channel-rows">
                        <div v-for="item in foreign" @click="changeSp(item)" :key="item.id" :class="['channel-item', item.active ? 'active' : '']">
                            <el-image :src="$utils.coverImg(item.showLogo, 260, 260)" fit="cover">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                            <i :class="[item.active ? 'el-icon-success' : '',  'icon']"></i>
                            <p>{{ item.showName || item.name  }}</p>
                            <!-- <span>（包含多个渠道）</span> -->
                        </div>
                        <div class="channel-item active more">
                            <el-image :src="require('@/assets/img/foreign.png')" fit="cover">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                            <i class="el-icon-success icon"></i>
                            <p>等其余144个平台</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="exposure-index">
                <p>预计曝光指数</p>
                <div class="count">
                    <DigitRoll :rollDigits="exposureIndex" />
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onClose">取消</el-button>
            <el-button type="primary" @click="save">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import DigitRoll from '@huoyu/vue-digitroll';
export default {
    components: {
        DigitRoll
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            domestic: [],
            foreign: [],
            exposureIndex: 100,
            timeOut: null,
            spIds: []
        };
    },
    mounted () {
        this.getSp();
    },
    methods: {
        async getSp () {
            const response = await this.$request({
                url: '/spUser/selectedList',
                method: 'POST'
            });
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            const {selectedDomesticSpUsers, selectedForeignSpUsers} = result;
            this.domestic = (selectedDomesticSpUsers || []).map(item => {
                const index = this.spIds.findIndex(element => element === item.id);
                item.active = index >= 0 ? false : true;
                return item;
            });
            this.foreign = (selectedForeignSpUsers || []).map(item => {
                const index = this.spIds.findIndex(element => element === item.id);
                item.active = index >= 0 ? false : true;
                return item;
            });
        },
        setSpId() {
            const {domestic, foreign} = this;
            const spIds = [];
            domestic.forEach(element => {
                if(!element.active) spIds.push(element.id);
            });
            foreign.forEach(element => {
                if(!element.active) spIds.push(element.id);
            });
            this.spIds = spIds;
        },
        save(){
            this.$emit('onData', this.spIds);
            this.onClose();
        },
        setExposureIndex () {
            if(this.timeOut) return;
            this.timeOut = setTimeout(() => {
                clearTimeout(this.timeOut);
                this.timeOut = null;
                const {domestic, foreign} = this;
                let index = 0;
                domestic.forEach(element => {
                    if(element.active) index += element.score;
                });
                foreign.forEach(element => {
                    if(element.active) index += element.score;
                });
                this.exposureIndex = parseInt(index + 10);
            }, 1300);
        },
        changeSp (item) {
            item.active = !item.active;
            this.setSpId();
            this.setExposureIndex();
        },
        onClose () {
            this.$emit('update:visible', false);
        }
    }
};
</script>
<style lang="scss">
.channel-dialog-content {
    margin-bottom: 10px;
    .channel-list {
        display: flex;
        text-align: center;
        .left, .right {
            flex: 1;
            padding: 0 20px;
            .title {
                color: #000;
                font-size: 16px;
                font-weight: 600;
            }
        }
        .right {
            border-left: 1px solid #eee;
        }
        .channel-rows {
            margin: 20px 0;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-row-gap: 20px;
            grid-column-gap: 10px;
            .el-image {
                width: 60px;
                height: 60px;
                border-radius: 50%;
                overflow: hidden;
            }
            p {
                color: #333;
                font-weight: 400;
                margin-top: 10px;
            }
            .channel-item {
                position: relative;
                cursor: pointer;
                height: 120px;
                i.icon {
                    position: absolute;
                    top: 40px;
                    right: 35px;
                }
                &.more {
                    cursor: default;
                    opacity: .6;
                }
            }
            .active {
                i.icon {
                    font-size: 20px;
                    color: #5914ee;
                }
            }
        }
    }
    .exposure-index {
        text-align: center;
        margin-top: 40px;
        p {
            color: #666;
            margin-bottom: 10px;
            font-size: 13px;
            font-weight: bold;
        }
        .count {
            width: 60px;
            margin: 0 auto;
            position: relative;
            &::before {
                content: "";
                position: absolute;
                background-color: #F8F7FC;
                width: 100px;
                height: 60px;
                top: -5px;
                left: -20px;
                border-radius: 4px;
            }
            .d-roll-item div {
                font-size: 28px;
                font-weight: bold;
                color: #5914ee;
            }
        }
    }
}
</style>
